/** Production preview: ?history enables vs Hist column + fusion_history.php API. */

export const HISTORY_PREVIEW_STORAGE_KEY = 'fusion_history_preview';

function searchHasHistory(search) {
  if (!search) return false;
  const normalized = search.startsWith('?') ? search : `?${search}`;
  return new URLSearchParams(normalized).has('history');
}

function urlHasHistory(urlString) {
  if (!urlString) return false;
  try {
    const url = new URL(urlString);
    return searchHasHistory(url.search);
  } catch {
    return false;
  }
}

function readStorageFlag() {
  try {
    return localStorage.getItem(HISTORY_PREVIEW_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/** Synchronous checks (iframe URL, referrer, localStorage override). */
export const isHistoryFeatureEnabled = () => {
  if (typeof window === 'undefined') return false;

  if (readStorageFlag()) return true;
  if (searchHasHistory(window.location.search)) return true;

  if (window.self !== window.top) {
    try {
      if (searchHasHistory(window.parent.location.search)) return true;
    } catch {
      // cross-origin parent
    }
    if (urlHasHistory(document.referrer)) return true;
  }

  return false;
};

const TRUSTED_PARENT_ORIGINS = [
  'https://www.opcioguru.com',
  'https://opcioguru.com',
  'http://localhost:3000',
];

export function isTrustedParentOrigin(origin) {
  return TRUSTED_PARENT_ORIGINS.includes(origin);
}

/** Ask opcioguru.com parent page to forward ?history (see public/fusion-parent-bridge.js). */
export function requestHistoryFromParent(onEnabled) {
  if (typeof window === 'undefined' || window.self === window.top) return undefined;

  const handleMessage = (event) => {
    if (!isTrustedParentOrigin(event.origin)) return;
    if (!event.data || event.data.type !== 'fusion:history') return;
    onEnabled(Boolean(event.data.enabled));
  };

  window.addEventListener('message', handleMessage);

  TRUSTED_PARENT_ORIGINS.forEach((origin) => {
    try {
      window.parent.postMessage({ type: 'fusion:init' }, origin);
    } catch {
      // ignore
    }
  });
  try {
    window.parent.postMessage({ type: 'fusion:init' }, '*');
  } catch {
    // ignore
  }

  return () => window.removeEventListener('message', handleMessage);
}
